import { useErrorHandlingMutation } from '@backoffice-frontend/data-fetching'
import {
  Body1,
  Divider,
  MoiaDialog,
  MoiaDialogContent,
  MoiaDialogFormFooter,
  useTheme,
} from '@backoffice-frontend/patterns'
import { PersonXIcon } from '@moia-dev/pace-icons'
import { Button } from '@moia-dev/pace-web'
import type { SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { useAdVehicleStreamConfirmManualNoShowMutation } from './BoardingPassengers.hook'

export const ConfirmManualNoShowDialog = ({
  tripId,
  vehicleId,
  isDialogOpen,
  setIsDialogOpen,
}: {
  tripId: string
  vehicleId: string
  isDialogOpen: boolean
  setIsDialogOpen: (isOpen: SetStateAction<boolean>) => void
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const [confirmManualNoShow] = useErrorHandlingMutation(
    useAdVehicleStreamConfirmManualNoShowMutation,
  )

  const confirmNoShow = async () => {
    await confirmManualNoShow({
      variables: {
        tripId,
        vehicleId,
      },
    })
    setIsDialogOpen(false)
  }

  return (
    <MoiaDialog
      maxWidth="xs"
      open={isDialogOpen}
      onClose={() => setIsDialogOpen(false)}
      header={t('map_confirmNoShow_button')}
    >
      <Divider />
      <MoiaDialogContent>
        <Body1
          css={{
            marginBottom: theme.space.Space3,
          }}
        >
          {t('adFleetMap_dialog_noShowConfirmation_caption')}
        </Body1>
      </MoiaDialogContent>
      <MoiaDialogFormFooter
        trailing={
          <>
            <Button
              label={t('common_cancel_button')}
              variant="secondary"
              onClick={() => setIsDialogOpen(false)}
            />
            <Button
              label={t('map_confirmNoShow_button')}
              variant={'primary'}
              icon={<PersonXIcon />}
              onClick={confirmNoShow}
            />
          </>
        }
      />
    </MoiaDialog>
  )
}
